import { render, staticRenderFns } from "./printOrder.vue?vue&type=template&id=1c84cff8&scoped=true"
import script from "./printOrder.vue?vue&type=script&lang=js"
export * from "./printOrder.vue?vue&type=script&lang=js"
import style0 from "./printOrder.vue?vue&type=style&index=0&id=1c84cff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84cff8",
  null
  
)

export default component.exports